import { useForm } from "react-hook-form";

import { handled } from "@/helpers";

import Button from "../common/input/button";
import Input from "../common/input/input";

interface AssessmentStepFormValues {
  name: string;
}

// toggleFn arrives from the surrounding Modal through cloneElement, never from the call site.
interface AssessmentStepFormProps {
  name?: string;
  callbackFn: (name: string) => void;
  toggleFn?: () => void;
}

export default function AssessmentStepForm({
  name,
  callbackFn,
  toggleFn,
}: AssessmentStepFormProps) {
  const { handleSubmit, register } = useForm<AssessmentStepFormValues>({
    defaultValues: { name: name ?? "" },
  });

  const _handleSubmit = (data: AssessmentStepFormValues) => {
    callbackFn(data.name);
    toggleFn?.();
  };

  const _handleCancel = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    toggleFn?.();
  };

  return (
    <form
      onSubmit={handled(handleSubmit(_handleSubmit))}
      className="mt-4 w-[32rem] rounded-lg bg-slate-800 p-8"
    >
      <Input id="name" name="name" register={register} label="Name" />
      <div className="flex items-center gap-4">
        <Button type="submit">Submit</Button>
        <Button onClick={_handleCancel}>Cancel</Button>
      </div>
    </form>
  );
}
